import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {GetAddonDataRequestParamsType, GetAddonDataResponseType} from "@CheckOrder/api/types/GetAddonData.type";
import {SetActiveAddonRequestParamsType, SetActiveAddonResponseType} from "@CheckOrder/api/types/SetActiveAddon.type";
import {
    RemoveActiveAddonRequestType,
    RemoveActiveAddonResponseType
} from "@CheckOrder/api/types/RemoveActiveAddon.type";
import {SurveyResponseType} from "@CheckOrder/api/types/SurveyResponse.type";
import {SurveyRequestType} from "@CheckOrder/api/types/SurveyRequest.type";
import {UpdateSeatSelectionRequestType} from "@CheckOrder/api/types/UpdateSeatSelectionRequest.type";
import {UpdateSeatSelectionResponseType} from "@CheckOrder/api/types/UpdateSeatSelectionResponse.type";

// Define a service using a base URL and expected endpoints
export const checkOrderApi = createApi({
    reducerPath: 'checkOrderApi',

    baseQuery: fetchBaseQuery({
        // baseUrl: `${GBB_URL}/api/mobile/v3/`
        headers: {
            'Content-Type': 'application/json',
            "X-Requested-With": "XMLHttpRequest",
            referer: "https://getbybus.com",
        },
    }),

    tagTypes: ['ActiveTicket', 'ActiveVoucher'],

    endpoints: (builder) => ({
        getAddon: builder.query<GetAddonDataResponseType, GetAddonDataRequestParamsType>({
            query: (params) => ({
                url: '/ajax/get-addon-data',
                method: 'GET',
                params,
            }),
        }),
        setAddon: builder.query<SetActiveAddonResponseType, SetActiveAddonRequestParamsType>({
            query: (body) => ({
                url: '/ajax/set-active-addon',
                method: 'POST',
                body,
            }),
        }),
        removeAddon: builder.query<RemoveActiveAddonResponseType, RemoveActiveAddonRequestType>({
            query: (body) => ({
                url: '/ajax/remove-active-addon',
                method: 'POST',
                body,
            }),
        }),
        getSurvey: builder.query<SurveyResponseType, SurveyRequestType>({
            query: (params) => ({
                url: '/ajax/survey',
                method: 'GET',
                params,
            }),
        }),
        updateSeatSelection: builder.query<UpdateSeatSelectionResponseType, UpdateSeatSelectionRequestType>({
            query: (body) => ({
                url: '/ajax/update-seat-selection',
                method: 'POST',
                body,
            }),
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useLazySetAddonQuery,
    useLazyGetAddonQuery,
    useLazyRemoveAddonQuery,
    useGetSurveyQuery,
    useLazyUpdateSeatSelectionQuery,
} = checkOrderApi